import {
  AccountBoxOutlined,
  Help,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { FC } from "react";
import styled from "styled-components";

import { SVG_MUI } from "@ryde/assets";
import { IStyledAttributes } from "@ryde/shared";

export const MobileSettingsSearchWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "mobile-settings-search-wrapper",
  },
)`
  display: flex;
  align-items: center;
  padding-inline-start: 15px;
  padding-bottom: 10px;
`;

export const ImgLangEnSvg = (): React.ReactNode => {
  return <SVG_MUI.LangSVG />;
};

export const ImgLangHeSvg = (): React.ReactNode => {
  return <SVG_MUI.LangHeSVG />;
};

export const ImgExitButton: FC<{ onClick: () => void }> = ({
  onClick,
}): React.ReactNode => {
  return (
    <IconButton onClick={onClick} sx={{ padding: 0 }}>
      <LogoutIcon color="primary" />
    </IconButton>
  );
};

export const ImgProfileButton: FC<{ onClick: () => void }> = ({
  onClick,
}): React.ReactNode => {
  return (
    <IconButton onClick={onClick} sx={{ padding: 0 }}>
      <AccountBoxOutlined color="primary" />
    </IconButton>
  );
};

export const ImgHelpPageRedirectButton: FC<{ onClick: () => void }> = ({
  onClick,
}): React.ReactNode => {
  return (
    <IconButton onClick={onClick} sx={{ padding: 0 }}>
      <Help color="primary" />
    </IconButton>
  );
};
